import { Dir } from '@angular/cdk/bidi';
import { ChangeDetectorRef, TemplateRef, } from '@angular/core';
/**
    * Max length for property names. Any names bigger than this get trunctated.
    */
var KEY_MAX_LENGTH = 30;
var UiJsonFormatterComponent = /** @class */ (function () {
    function UiJsonFormatterComponent(_changeDetectorRef, _dir) {
        this._changeDetectorRef = _changeDetectorRef;
        this._dir = _dir;
        this.isExpandable = false;
        this.emptyPlaceholder = 'Empty';
        this.objectPlaceholder = 'Object';
        this._open = false;
        this._levelsOpen = 0;
    }
    Object.defineProperty(UiJsonFormatterComponent.prototype, "levelsOpen", {
        get: function () {
            return this._levelsOpen;
        },
        /**
         * levelsOpen?: number
         * Levels opened by default when JS object is formatted and rendered.
         */
        set: function (levelsOpen) {
            if (!Number.isInteger(levelsOpen)) {
                throw new Error('[levelsOpen] needs to be an integer.');
            }
            this._levelsOpen = levelsOpen;
            this._open = levelsOpen > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiJsonFormatterComponent.prototype, "open", {
        get: function () {
            return this._open;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiJsonFormatterComponent.prototype, "key", {
        get: function () {
            var elipsis = this._key && this._key.length > KEY_MAX_LENGTH ? '…' : '';
            return this._key ?
                this._key.substring(0, KEY_MAX_LENGTH) + elipsis
                : '';
        },
        /**
         * key?: string
         * Tag to be displayed next to formatted object.
         */
        set: function (key) {
            this._key = key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiJsonFormatterComponent.prototype, "data", {
        get: function () {
            return this._data;
        },
        /**
         * data: any
         * JS object to be formatted.
         */
        set: function (data) {
            this._data = data;
            this._parseChildren();
            this.isExpandable = this._children &&
                this._children.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiJsonFormatterComponent.prototype, "children", {
        get: function () {
            return this._children;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiJsonFormatterComponent.prototype, "isRTL", {
        get: function () {
            if (this._dir) {
                return this._dir.dir === 'rtl';
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Refreshes json-formatter and rerenders [data]
     */
    UiJsonFormatterComponent.prototype.refresh = function () {
        this._changeDetectorRef.markForCheck();
    };
    /**
     * Toggles collapse/expanded state of component.
     */
    UiJsonFormatterComponent.prototype.toggle = function () {
        this._open = !this._open;
    };
    UiJsonFormatterComponent.prototype.isObject = function () {
        return this.getType(this._data) === 'object';
    };
    UiJsonFormatterComponent.prototype.isArray = function () {
        return Array.isArray(this._data);
    };
    UiJsonFormatterComponent.prototype.isEmpty = function () {
        var type = this.getType(this._data);
        if (type === 'string' && !this._data) {
            return true;
        }
        if (type === 'object' && !this.isExpandable) {
            return true;
        }
        return false;
    };
    UiJsonFormatterComponent.prototype.hasChildren = function () {
        return this._children && this._children.length > 0;
    };
    /**
     * Gets parsed value depending on value type.
     */
    UiJsonFormatterComponent.prototype.getValue = function (value) {
        var type = this.getType(value);
        if (type === 'undefined' || (type === 'null')) {
            return type;
        }
        if (type === 'date') {
            value = new Date(value).toString();
        }
        if (type === 'function') {
            // Remove content of the function
            return value.toString()
                .replace(/[\r\n]/g, '')
                .replace(/\{.*\}/, '') + '{…}';
        }
        if (Array.isArray(value)) {
            return this.getObjectName() + ' [' + value.length + ']';
        }
        return value;
    };
    /**
     * Gets type of object.
     * returns 'null' if object is null and 'date' if value is object and can be parsed to a date.
     */
    UiJsonFormatterComponent.prototype.getType = function (object) {
        if (typeof object === 'object') {
            if (!object) {
                return 'null';
            }
            if (Array.isArray(object)) {
                return 'object';
            }
            var date = new Date(object);
            if (Object.prototype.toString.call(date) === '[object Date]' &&
                !Number.isNaN(date.getTime())) {
                return 'date';
            }
        }
        return typeof object;
    };
    /**
     * Generates string representation depending if its an object or function.
     * see: http://stackoverflow.com/a/332429
     */
    UiJsonFormatterComponent.prototype.getObjectName = function () {
        var object = this._data;
        if (this.isObject() && !object.constructor) {
            return this.objectPlaceholder;
        }
        var funcNameRegex = /function (.{1,})\(/;
        var results = (funcNameRegex).exec((object).constructor.toString());
        if (results && results.length > 1) {
            return results[1] === 'Object' ? this.objectPlaceholder : results[1];
        }
        return '';
    };
    UiJsonFormatterComponent.prototype._parseChildren = function () {
        if (this.isObject()) {
            this._children = [];
            for (var key in this._data) {
                if (this._data) {
                    this._children.push(key);
                }
            }
        }
    };
    return UiJsonFormatterComponent;
}());
export { UiJsonFormatterComponent };
